'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef, useState } from 'react';
import classnames from 'classnames';
import { Image } from '../../index.js';
export const imageMagnifierWindowSizes = {
    small: {
        width: 250,
        height: 250,
    },
    large: {
        width: 742,
        height: 742,
    },
};
const getZoomWindowSize = (size) => {
    return imageMagnifierWindowSizes[size];
};
export const ImageMagnifer = ({ className, disableMagnifier, followMousePosition = true, handleMagnifierWindowRender, handleHoverStart, handleHoverMove, handleHoverEnd, imgSrc, imgAlt, zoomLevel = 1.5, imageComponent, imageComponentProps, magnifierSize = 'small', }) => {
    const windowRef = useRef(null);
    const zoomRef = useRef(null);
    const [[x, y], setXY] = useState([0, 0]);
    const [[imgWidth, imgHeight], setSize] = useState([0, 0]);
    const [showMagnifier, setShowMagnifier] = useState(false);
    const magnifierWindowSize = getZoomWindowSize(magnifierSize);
    const magnifierPosition = useMemo(() => {
        if (followMousePosition) {
            return {
                top: `${y - magnifierWindowSize.height / 2}px`,
                left: `${x - magnifierWindowSize.width / 2}px`,
            };
        }
        return {
            top: 0,
            left: imgWidth,
        };
    }, [
        followMousePosition,
        imgWidth,
        magnifierWindowSize.height,
        magnifierWindowSize.width,
        x,
        y,
    ]);
    const componentClassName = classnames('sparky-c-image-magnifer', className, {});
    const hoverStart = (e) => {
        const elem = e.currentTarget;
        const { width, height } = elem.getBoundingClientRect();
        setSize([width, height]);
        setShowMagnifier(true);
        handleHoverStart === null || handleHoverStart === void 0 ? void 0 : handleHoverStart(e);
    };
    const hoverMove = (e) => {
        const elem = e.currentTarget;
        const { top, left } = elem.getBoundingClientRect();
        const x = e.pageX - left - window.pageXOffset;
        const y = e.pageY - top - window.pageYOffset;
        setXY([x, y]);
        handleHoverMove === null || handleHoverMove === void 0 ? void 0 : handleHoverMove(e);
    };
    const hoverEnd = (e) => {
        setShowMagnifier(false);
        handleHoverEnd === null || handleHoverEnd === void 0 ? void 0 : handleHoverEnd(e);
    };
    const magnifierWindow = (_jsx("div", { ref: windowRef, className: "sparky-c-image-magnifer__window", style: Object.assign(Object.assign({ display: showMagnifier ? '' : 'none' }, magnifierPosition), { width: magnifierWindowSize.width, height: magnifierWindowSize.height, backgroundImage: `url('${imgSrc}')`, backgroundSize: `${imgWidth * zoomLevel}px ${imgHeight * zoomLevel}px`, backgroundPositionX: `${-x * zoomLevel + magnifierWindowSize.width / 2}px`, backgroundPositionY: `${-y * zoomLevel + magnifierWindowSize.height / 2}px` }) }));
    const magnifierImage = (_jsx(Image, Object.assign({ className: "sparky-c-image-magnifer__image", src: imgSrc, onMouseEnter: hoverStart, onMouseMove: hoverMove, onMouseLeave: hoverEnd, alt: imgAlt, alternativeComponent: imageComponent }, imageComponentProps)));
    if (disableMagnifier) {
        return magnifierImage;
    }
    return (_jsxs("div", Object.assign({ className: componentClassName }, { children: [!followMousePosition && showMagnifier && (_jsx("div", { ref: zoomRef, className: "sparky-c-image-magnifer__zoom", style: {
                    width: magnifierWindowSize.width / zoomLevel,
                    height: magnifierWindowSize.height / zoomLevel,
                    top: y - magnifierWindowSize.height / zoomLevel / 2,
                    left: x - magnifierWindowSize.width / zoomLevel / 2,
                } })), magnifierImage, handleMagnifierWindowRender
                ? handleMagnifierWindowRender(magnifierWindow)
                : magnifierWindow] })));
};
//# sourceMappingURL=ImageMagnifer.js.map